// web-ctr/src/components/ui/Spinner.jsx
export default function Spinner({ className = '' }) {
  return (
    <span
      aria-label="Loading"
      className={`inline-block h-4 w-4 animate-spin rounded-pill border-[2.5px] border-line border-t-accent ${className}`}
    />
  );
}
